import HomeLayout from './HomeLayout.container';

export default HomeLayout;
